import {session} from '@netx/core-auth/collections/singleton/session';

export const getAuthorizationHeader = () => {
	const token = session.getToken();
	return {
		Authorization: token
			? `shareToken ${token}`
			: `sessionKey ${session.get('sessionKey')}`,
	};
};

export default getAuthorizationHeader;
